var _use, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSessions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "user",
    xlinkHref: "#_Image1",
    x: 8.5,
    y: 7.5,
    width: "38px",
    height: "40px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "38px",
    height: "40px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAoCAYAAACSN4jeAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADVElEQVRYhe3XTWgcZRzH8c+uwTcsYonSy1TEEMggSGoIWSstWGkOhYhKKSoVEU9CD168WHJQKurBY041iClKDipUcohYQUUnFE3whQ2IInYuxYYUafElVeph/ks22u5O1qSr4O/yMM/zf37znef1PxUdql5LtuEgRjGIrdG0jAXMYirN8tOd+Fc6ANqC5/AUrm4TvoIJjKdZfm7TwOq1ZADH0RdVc5jGCeRRl2APDmAk6r7FWJrlixsOFlAfoTcgnkyz/L02ffbiaMAuYVdZuFJgMX3zipE6iX1pli+V7NuLGQwrRm5HmWmtljFXrKk+xUiVhoKI3Rd9+8KrrdqOWOy+HxQLfbTd9LXw2avYqSu4td1uLTNiBwNqrlMoiL5z4XWwXXwZsNEopzuFalLDY7RllHJgg1Ge6BhnVQ2PwZZRyoE1TvS8ZVQ5NTy2toxSfldecZUBW44y2YD3NTyWW0YpB7YQ5Z6OcVbV8FhoGaUc2GyUBzrGWVXDY7ZllHJgU4pDcSQOyY4UfUfCa+ofg8UJPRGPR+PuWy9Ur+Iyh4kyOVrZXTmuuIATzKwHrukST8JjvEy/UmCRDYwpUpdhzJeZ1oiZjz5LipysVML4308Um+D+fal1szb7Z+R/rVfr+RmpYAC7cCdux224GddZXW8r+AVn8D2+wxeKH5nFNMsvbghYvZbswGN4GLeU/ZDL6Ee8idfTLJ/vCKxeS4ZxBPc1VZ/HJ/gcX+MUTuMn/B4xPbgR27Add+Au7MQNTV7v49k0y0+WAqvXkmvwAp6O9j/wFl7DB2mW/9bqSy+n8L0Xj+MhXIWLeCUA1/hW/tL5JsUBek9UTeOZNMtPdQLTAnI7XraabXyM+9MsP/s3sHotuR4fYgjn8Gia5e9uJNAlAMdwDFvwGXanWf4za+/KyYBaxs7NhoI0y48r1t5yvHuy0VYJ8gfwtmIB706z/NPNhmpWvZbcrZitHjyYZvk7lXotqWIR/TiSZvnhKwnVBPc8DuMbDFQVd10/zuLFbkCFXgqGfoxWsT8ajqVZfr5bVPHuRsq9v2o1Z5rpDtIaNRhGqoqhgy+7BNOsr6Lsr+JCPAzFRd1NDUV5oVKvJa/iiW7SXEKTPTgUD4/g2i7CwK94A4f+BAcaEwotyXf+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSessions);
export default __webpack_public_path__ + "static/media/user-sessions.c9ef6b884c6f49693bcf3db2b6356ce3.svg";
export { ForwardRef as ReactComponent };